import Hashids from "hashids";

/** Misma config que reports / portal-seguroskc. */
const HASHIDS_SALT = "GrupoKCSeguros2026!@#";
const HASHIDS_MIN_LENGTH = 8;

const hashids = new Hashids(HASHIDS_SALT, HASHIDS_MIN_LENGTH);

export const encodeId = (id: number): string => hashids.encode(id);

export const encodeCotizacionId = (idCotizacion: number | string): string => {
  const numericId = typeof idCotizacion === "number" ? idCotizacion : Number(idCotizacion);
  if (!Number.isFinite(numericId) || numericId <= 0) {
    throw new Error(`id_cotizacion inválido: ${idCotizacion}`);
  }
  return encodeId(numericId);
};
